<template>

  <div>
    
    <v-btn
      outlined
      class="text-none mb-4 pl-3 pr-3"
      color="gray12Color"
      style="background: var(--v-whiteColor-base);"
      @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy`)"
    >
      <i class="material-icons-outlined mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">arrow_back</i> <span style="color: var(--v-blackColor-base);">Back to Keyword Strategy</span>
    </v-btn>

    <div class="container d-flex flex-column align-center" style="text-align: center;">

      <div class="mb-4" style="color: var(--v-gray50Color-base); margin-bottom: 6px; font-size: 1rem;">{{ site.name }}</div>
    
      <div class="card-big-title mb-4 d-flex gap10" style="color: var(--v-blackColor-base); font-size: 1.8rem; font-weight: 700;">
        Custom silo
        <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
          @click="() => {
            $store.commit('setCurrentVideoTutorialToDisplay', {
              title: 'How Pros Build Custom SEO Silos (Full Control)',
              videoLink: 'https://www.youtube.com/embed/d-as3x6gn7U',
              description: 'In this video, Heather Cumins, a Customer Success Manager at PageOptimizer Pro, shows you how to use POP’s Custom Silo to turn up to 10 target keywords or 20 competitor URLs into a fully ready, implementable content strategy.',
              time: '5m 27s'
            });
          }">
          videocam
        </span>
      </div>

      <div
        class="mb-8"
        style="max-width: 650px; font-size: 1rem; line-height: 1.5;"
      >
        Use this option if you want full control over your keyword research. Enter up to 10 keywords or up to 20 competitor URLs, explore the keyword list, and apply filters to tailor your silo to your strategy.
      </div>

      <!-- Form -->
      <div class="white-common-box">
        <div style="width: 1000px;">
  
          <div class="mt-4 mb-6 keyword-strategy-tab-group">
            <v-btn-toggle>
              <v-btn
                :class="{ 'v-btn--active': mode === 'topics' }"
                @click="mode = 'topics'"
              >
                Enter topic
              </v-btn>
              <v-btn
                :class="{ 'v-btn--active': mode === 'competitors' }"
                @click="mode = 'competitors'"
              >
                Analyze competitors
              </v-btn>
            </v-btn-toggle>
          </div>
          
          <template v-if="mode === 'topics'">
  
            <div
              class="d-flex align-center gap5 mb-4 ps-7 pe-7"
              style="justify-content: space-between;"
            >
            <div class="d-flex align-center gap5">
              <span style="font-weight: 700; font-size: 1rem; color: var(--v-blackColor-base);">Enter your target keyword or topic</span>
  
              <b-dropdown aria-role="list" position="is-bottom-right" hoverable>
                <template #trigger>
                  <i class="material-icons" style="color: var(--v-gray9Color-base);">info</i>
                </template>
  
                <b-dropdown-item custom style="width: 400px;">
                  <div class="p-2">
                    <div class="mb-2 font-weight-bold" style="color: var(--v-blackColor-base);">How to select topics:</div>
                    <div class="mb-3" style="color: var(--v-blackColor-base);">You can enter up to 10 topics. Some use cases: </div>
                    <div class="d-flex gap10 mb-3 ml-2" style="color: var(--v-blackColor-base);">
                      <i class="material-icons-outlined" style="color: #23BF87; font-size: 1rem; margin-top: 2px;">check</i>
                      you can add one topic (keyword) for one URL, e.g. “relocation to italy”
                    </div>
                    <div class="d-flex gap10 mb-3 ml-2" style="color: var(--v-blackColor-base);">
                      <i class="material-icons-outlined" style="color: #23BF87; font-size: 1rem; margin-top: 2px;">check</i>
                      you can add multiple topics for one URL, e.g. “relocation to italy” and “italy residence permit”
                    </div>
                    <div class="d-flex gap10 mb-3 ml-2" style="color: var(--v-blackColor-base);">
                      <i class="material-icons-outlined" style="color: #23BF87; font-size: 1rem; margin-top: 2px;">check</i>
                      you can add multiple topics for several URLs at a time, e.g. “italy residence permit” for one page and “work permit italy” for another
                    </div>
                    <div class="d-flex gap10 ml-2" style="color: var(--v-blackColor-base);">
                      <i class="material-icons-outlined" style="color: #E92F29; font-size: 1rem; margin-top: 2px;">clear</i>
                      try to stay away from very broad keywords such as “italy” or “visa”
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
  
              <span class="input-count-info"
                :style="(topics?.length || 0) > 10 ? 'color: red; border-color: red;' : ''"
              >{{ topics?.length || 0 }} / 10</span>
            </div>

                <div class="lang-loc-fields">
            <v-autocomplete dense solo hide-details="auto"
              append-icon="keyboard_arrow_down"
              :items="availableLocations"
              item-text="location_name"
              item-value="location_code"
              v-model="selectedLocation"
              color="grayColor">
            </v-autocomplete>
        
            <v-autocomplete dense solo hide-details
              append-icon="keyboard_arrow_down"
              :items="availableLanguages"
              v-model="selectedLanguage"
              item-text="language_name"
              item-value="language_code"
              color="grayColor">
            </v-autocomplete>
        

            </div>
              
            </div>

            
            
  
            <div
              class="keyword-field-area mb-6"
            >
  
              <div class="customized-multiselect1">
                <multiselect class="mt-5"
                  v-model="topics"
                  placeholder="Enter keywords or topics you want to explore"
                  :options="[]"
                  :multiple="true"
                  :taggable="true"
                  :optionsLimit="10"
                  @tag="addTopicAction">
                </multiselect>
              </div>
  
        
  
            </div>

            <div class="mb-4" style="text-align: left; max-width: 946px; margin: auto;">
              <v-tooltip top color="transparent">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="display: inline-block;">
                    <v-checkbox
                      class="subdomains-checkbox"
                      style="display: inline-flex;"
                      color="#007aff"
                      hide-details
                      :ripple="false"
                      :input-value="!include_subdomains_in_analysis"  
                      @change="include_subdomains_in_analysis = !$event"
                    >
                      <template v-slot:label>
                        <div style="color: var(--v-blackColor-base); font-size: 0.9rem;">
                          Do not include sub-domains in analysis
                        </div>
                      </template>
                    </v-checkbox>
                  </div>
                </template>
                <div class="white-bg-tooltip small-tooltip" style="color: var(--v-blackColor-base);">
                  Only count rankings for URLs on your main site (example.com and www.example.com). Rankings on subdomains (like blog.example.com) will be ignored.
                </div>
              </v-tooltip>
            </div>
  
          </template>
  
          <template v-else-if="mode === 'competitors'">
            
            <div
              class="d-flex align-center gap5 mb-4"
              style="justify-content: center;"
            >
              <span style="font-weight: 700; font-size: 1rem; color: var(--v-blackColor-base);">Enter your competitor URLs</span>
  
              <b-dropdown aria-role="list" position="is-bottom-right" hoverable>
                <template #trigger>
                  <i class="material-icons" style="color: var(--v-gray9Color-base);">info</i>
                </template>
  
                <b-dropdown-item custom style="width: 400px;">
                  <div class="p-2">
                    <div class="mb-3 font-weight-bold" style="color: var(--v-blackColor-base);">How to select competitor URLs:</div>
                    <div class="d-flex gap10 mb-3" style="color: var(--v-blackColor-base);">
                      <i class="material-icons-outlined ml-2" style="color: #23BF87; font-size: 1rem; margin-top: 2px;">check</i>
                      URLs should link directly to specific features or product pages, e.g. use https://www.domain.com/platform/marketing-automation
                    </div>
                    <div class="d-flex gap10" style="color: var(--v-blackColor-base);">
                      <i class="material-icons-outlined ml-2" style="color: #E92F29; font-size: 1rem; margin-top: 2px;">clear</i>
                      Try to stay away from homepage URLs, e.g. https://www.domain.com/
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
  
              <span class="input-count-info"
                :style="(competitorsList?.length || 0) > 20 ? 'color: red; border-color: red;' : ''"
              >{{ competitorsList?.length || 0 }} / 20</span>
              
            </div>
  
            <div
              class="mb-6"
              style="max-width: 1100px;"
            >
              <v-textarea
                class="competitors-field"
                outlined
                hide-details
                color="greenColor"
                placeholder="Enter a list of URLs (separated by line breaks)"
                v-model="competitorsText"
              />
            </div>
  
          </template>
          <div class="d-flex flex-column align-start ps-6 ">
            <v-btn
              color="profileAnchorColor"
              class="whiteColor--text mb-3"
              style="text-transform: none;"
              large
              :loading="submitting"
              :disabled="!canProceed || (isWhiteGloveUser && !(isMissionControlSession))"
              @click="() => hasUnlimitedAccess?startResearch():(() => {showSearchKeywordsCostModal = true})()"
            >
              <span style="font-size: 1.1rem;">Create my silo</span>
            </v-btn>
          </div>
          <div
            v-if="!hasUnlimitedAccess"
            class="d-flex align-center gap5 ps-5 pb-4"
            style="color: var(--v-gray2Color-base);"
          >
            <img v-if="$vuetify.theme.dark" src="/static/icon_credits_dark_mode.svg" /><img v-else src="/static/icon_credits_light_mode.svg" />  {{ mode === 'topics' ? '1 credit per topic' : '' }}{{ mode === 'competitors' ? '1 credit per 5 URLs' : '' }}
          </div>
        </div>
      </div>

    </div>

    <hr style="background-color: var(--v-gray12Color-base); height: 1px; margin: 3rem 0;" />

    <div class="container">

      <workflows-part class="mb-15" />

      <!-- Modals -->
      <!--------------------------------->

      <div class="modal search-keywords-cost-modal" v-if="showSearchKeywordsCostModal" :class="{'is-active': true}">
        <div class="modal-background" @click.stop="showSearchKeywordsCostModal = false"></div>
        <div class="modal-content">
          <div class="box modal-container">
            <div class="modal-content-root">
              <p class="title-font is-size-4 mainColor--text">Custom silo - get keywords</p>
              <div class="mainColor--text message-text" style="font-size: 1rem; line-height: 150%;">
                You have selected:
                <template v-if="mode === 'topics'">
                  <ul class="mt-2 mb-2" style="list-style: initial;">
                    <li class="font-weight-bold">{{ topics.length }} topic{{topics.length >1 ?'s':''}}</li>
                  </ul>
                  It will cost <span class="font-weight-bold">{{ topics.length }} POP Credit{{topics.length >1 ?'s':''}}</span> to search keywords for the selected items.<br />
                </template>
                <template v-if="mode === 'competitors'">
                  <ul class="mt-2 mb-2" style="list-style: initial;">
                    <li class="font-weight-bold">{{ competitorsList.length }} competitor url{{competitorsList.length >1 ?'s':''}}</li>
                  </ul>
                  It will cost <span class="font-weight-bold">{{ Math.ceil(competitorsList.length / 5) }} POP Credit{{Math.ceil(competitorsList.length / 5) >1 ?'s':''}}</span> to search keywords for the selected items.<br />
                </template>
              </div>
              <div class="d-flex justify-end gap10 mt-5">
                <v-btn rounded outlined color="mainColor"
                  class="text-none"
                  @click.stop="() => {
                    showSearchKeywordsCostModal = false;
                  }">
                  <span>Cancel</span>
                </v-btn>
                <v-btn rounded color="profileAnchorColor"
                  class="whiteColor--text text-none"
                  @click.stop="startResearch">
                  <span>Create my silo</span>
                </v-btn>
                
              </div>
            </div>
          </div>
          <button
            class="custom-modal-close-btn"
            aria-label="close"
            @click="() => (showSearchKeywordsCostModal = false)">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>

    </div>

    

  </div>

</template>

<script>
import Multiselect from 'vue-multiselect'

import languages from '@/consts/dataforseo_languages.json';
import dataForSeoLocations from '@/consts/dataforseo_locations.json';
import { getSplittedKeywords } from '@/components/Campaigns/CommonFunctions.js'
import WorkflowsPart from './WorkflowsPart.vue'

export default {
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    WorkflowsPart,
    Multiselect,
  },
  data () {
    return {
      selectedLocation: null,
      selectedLanguage: null,
      include_subdomains_in_analysis: true,

      mode: 'topics',

      topics: [],
      competitorsText: '',

      submitting: false,

      showSearchKeywordsCostModal: false,
    }
  },
  computed: {
    availableLocations () {
      return dataForSeoLocations.locations;
    },
    availableLanguages () {
      return languages;
    },
    competitorsList() {
      return this.competitorsText.split('\n').filter(item => item.trim())
    },
    canProceed () {
      if (this.submitting) {
        return false;
      }
      return (
        (this.mode === 'topics' && this.topics?.length > 0 && this.topics?.length <= 10)
        || (this.mode === 'competitors' && this.competitorsList?.length > 0 && this.competitorsList?.length <= 20)
        && Boolean(this.selectedLocation) && Boolean(this.selectedLanguage)
      )
    },
  },
  watch: {
    
  },
  methods: {
    addTopicAction (newVal) {
      if (newVal) {
        const topics = getSplittedKeywords(newVal)
        const result = [...this.topics, ...topics]
        this.topics = result.filter((k, pos) => result.indexOf(k) == pos)
      }
    },
    startResearch () {
      this.showSearchKeywordsCostModal = false;
      this.submitting = true;
        
      const formData = {
        campaignId: this.campaign?.id || 0,
        mode: this.mode,
        locationCode: this.selectedLocation,
        languageCode: this.selectedLanguage,
        include_subdomains_in_analysis: this.include_subdomains_in_analysis,
        ...this.mode === 'topics' ? {topics: this.topics} : {},
        ...this.mode === 'competitors' ? {competitors: this.competitorsList} : {},
      }

      this.$store.dispatch('siloResearchCustomSiloCreate', formData)
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.$store.commit('triggerAsyncTasksRefresh');
          this.reloadUser()
          this.$router.push(`/sites/${this.site.id}/campaign/${this.campaign.id}/keyword-strategy/custom-silo/${response.data.report.id}`)
          this.$notify({
            group: 'info', type: 'success',
            text: 'Custom Silo task has started!'
          })
        } else {
          this.$notify({
            group: 'info', type: 'error',
            text: response?.data?.msg || 'Failed to create Custom Silo task'
          })
        }
      })
      .finally(() => {
        this.submitting = false
      })
    },
  },
  mounted () {
    if (this.$route.query.initLanguage) {
      this.selectedLanguage = this.$route.query.initLanguage
    } else {
      this.selectedLanguage = this.campaign.languageCode
    }

    if (this.$route.query.initLocation) {
      this.selectedLocation = this.$route.query.initLocation ? Number(this.$route.query.initLocation) : ''
    } else {
      this.selectedLocation = this.campaign.locationCode ? Number(this.campaign.locationCode) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.keyword-strategy-tab-group {
  
  // NOTE: .v-btn class is repeated to give the css rule more weight
  .v-btn.v-btn.v-btn.v-btn {
    text-transform: none;
    border-color: #CCCCCC !important;
    background-color: var(--v-cardBg-base) !important;
    height: 38px !important;

    color: var(--v-blackColor-base) !important;

    &.v-btn--active {
      border: 1.11px solid #FF5700 !important;
      background: #FFEDDD !important;
      color: #000 !important;
      box-shadow: none !important;
      &::before {
        background: none !important;
      }
    }

    .v-btn__content {
      font-size: 0.95rem !important;
      font-weight: 500 !important;
      letter-spacing: normal;
    }
  }
}

.input-count-info {
  padding: 3px 7px;
  background: var(--v-whiteColor-base);
  color: var(--v-blackColor-base);
  font-size: 0.9rem;
  border-radius: 50vh;
  border: 1px solid var(--v-grayColor-base);
}

.customized-multiselect1::v-deep {
  .multiselect {
    .multiselect__element {
      background-color: var(--v-whiteColor-base) !important;
      // background-color: transparent !important;
    }
    .multiselect__select {
      &::before {
        border-width: 0 !important;
      }
    }
    .multiselect__tags {
      background-color: var(--v-whiteColor-base) !important;
      // background-color: transparent !important;
      border-color: var(--v-grayColor-base) !important;

      min-height: 58px;
      padding: 14px 40px 0 14px;

      input, .multiselect__single {
        background-color: var(--v-whiteColor-base) !important;
        color: var(--v-blackColor-base);
        font-size: 1rem;
        margin-top: 4px;
      }

      .multiselect__placeholder {
        font-size: 1rem;
        margin-top: 4px;
        padding-top: 0;
      }
    }
    .multiselect__tag {
      background-color: var(--v-gray7Color-base) !important;
      border: 1px solid var(--v-grayColor-base) !important;
      font-weight: bold;

      margin-bottom: 10px;

      span {
        color: var(--v-mainColor-base) !important;
      }
    }
    .multiselect__tag-icon::after {
      font-size: 1.2rem !important;
      color: var(--v-profileAnchorColor-base) !important;
    }
    .multiselect__tag-icon:hover {
      background: var(--v-grayColor-base) !important
    }
    ul.multiselect__content {
      padding-left: 0 !important;
    }
  }
}

.keyword-field-area {

  position: relative;

  max-width: 946px;
    margin: auto;

  .lang-loc-fields {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .keyword-field {
    ::v-deep {
      fieldset {
        border-color: var(--v-gray12Color-base);
        background-color: var(--v-whiteColor-base);
      }
  
      input {
        font-size: 1rem;
        margin-top: 12px !important;
        margin-bottom: 12px !important;
        line-height: 34px !important;
      }
    }
  }

}


.lang-loc-fields {
  display: flex;
  flex-direction: row;
  gap: 4px;

  ::v-deep {
    .v-select {
      .v-input__slot {
        box-shadow: none !important;
        background-color: var(--v-gray8Color-base) !important;

        input {
          font-size: .95rem;
          color: var(--v-blackColor-base) !important;
        }
      }
    }
  }
}

.competitors-field {
  ::v-deep {
    fieldset {
      border-color: var(--v-gray12Color-base);
      background-color: var(--v-whiteColor-base);
    }

    textarea {
      font-size: 1rem;
      margin-top: 12px !important;
      margin-bottom: 12px !important;
      line-height: 34px !important;
    }
  }
}
::v-deep {
  .subdomains-checkbox {
    margin-top: 0;
    padding-top: 0;
    .v-input__slot{
      padding-left: 0 !important;
    }
  }
}
</style>